import React from "react";
import { Link } from "react-router-dom";
import Header from "../../headerone/Main";
import Breadcrumb from "../../Breadcrumb/Main";
import { Container, Row, Col, Table } from "react-bootstrap";
import LeftAdministration from "./LeftAdministration";

function Main() {
  return (
    <>
      <Header />
      <Breadcrumb title="Home" subtitle="Administration" />
      <section className="project-detail">
        <div className="container">
          <div className="section-title center-align mb-50 wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s" >
            <h5><i className="fal fa-graduation-cap" /> Administration</h5>
            <h2>SENATE</h2>
          </div>
          <Row>
            <Col md={4} className="c-left ">
              <LeftAdministration activeIndex={2} />
            </Col>

            <Col md={8} className="c-left ">
              <table className="table table-striped">
                <tbody className="c-lineheight2 align-middle c-table">
                  <tr>
                    <td className="text-center">
                      <Link className='c-link'>Chairperson</Link>
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>
                    <Link
                          to="https://iittp.ac.in/director"
                          target="_blank;"
                        >
                        <b>Prof. K. N. Satyanarayana</b>
                        </Link>  
                      <br />
                      Director, IIT Tirupati
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/director.jpg" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Ex-officio</b></p>
                        </div>
                      </div></td>
                  </tr>
                  <tr>
                    <td className="text-center">
                      <Link className='c-link'>Secretary</Link>
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>
                    <b> Prof. Venkata Ramana Badarla</b>
                      <br />
                      Registrar In-charge, IIT Tirupati
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/ramana.jpg" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Ex-officio</b></p>
                        </div>
                      </div></td>
                  </tr>
                  <tr>
                    <td className="text-center">
                      <Link className='c-link'>Deans</Link>
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>
                    <b>Prof. A. Murali Krishna</b> <br />
                      Professor <br />
                      Dean, Planning and Infrastructure{" "}
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/AMK-NEW.jpg" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Ex-officio</b></p>
                        </div>
                      </div></td>
                  </tr>

                  <tr>
                    <td>
                    <b> Prof. E. Anil Kumar</b> <br />
                      Professor <br />
                      Dean, Sponsored Research and Consultancy
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/anil.jpg" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Ex-officio</b></p>
                        </div>
                      </div></td>
                  </tr>

                  <tr>
                    <td>
                    <b> Prof. Sasidhar Gumma</b> <br />
                      Professor <br />
                     Dean, Global Engagement, Alumni and Corporate Relations{" "}
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/SG.jpg" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Ex-officio</b></p>
                        </div>
                      </div></td>
                  </tr>

                  <tr>
                    <td>
                    <b>Prof. Muthukumar Palanisamy</b><br />
                      Professor <br />
                      Dean, Faculty Affairs
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/Prof.Muthukumar.jpg" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Member</b></p>
                        </div>
                      </div>
                    </td>
                  </tr>


                  <tr>
                    <td>
                    <b>Prof. KSMS Raghava Rao</b><br />
                      Professor <br />
                      Dean, Finance &amp; Administration  
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/raghavarao.png" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Ex-officio</b></p>
                        </div>
                      </div></td>
                  </tr>

                  <tr>
                    <td>
                    <b>Prof. Rama Krishna Sai Gorthi</b> <br />
                      Professor <br />
                      Dean, Academic Affairs
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/SubramanyamSai.JPG" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Ex-officio</b></p>
                        </div>
                      </div>
                    </td>
                  </tr>
                               
                  
                  
                  <tr>
                    <td>
                    <b>Prof. N N Murty</b> <br />
                      Dean, Student Affairs{" "}
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/nnmurthy.jpg" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Ex-officio</b></p>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                    <b>Prof. Arun K. Tangirala</b> <br />
                      Dean, Competency Development and Outreach (CDO){" "}
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/Prof_Arun_K_Tangirala.png" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Ex-officio</b></p>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-center">
                      <Link className='c-link'>Head of the Departments</Link>
                    </td>
                    <td></td>
                  </tr>

                  <tr>
                    <td>
                    <b>Prof. Anki Reddy Katha</b><br />
                      Professor <br />
                      Department of Chemical Engineering{" "}
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/anki.jpg" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Ex-officio</b></p>
                        </div>
                      </div></td>
                  </tr>
                  <tr>
                    <td>
                    <b>Prof. Gouriprasanna Roy</b><br />
                      Professor <br />
                      Department of Chemistry
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/Gouriprasanna Roy.jpg" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Ex-officio</b></p>
                        </div>
                      </div></td>
                  </tr>
                  <tr>
                    <td>
                    <b>Prof. Suresh Jain</b><br />
                      Professor <br />
                      Department of Civil and Environmental Engineering
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/SureshPP.JPG" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Ex-officio</b></p>
                        </div>
                      </div></td>
                  </tr>
                  <tr>
                    <td>
                    <b>Dr. Sridhar Chimalakonda</b><br />
                     Associate Professor <br />
                      Department of Computer Science and Engineering
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/chimalakonda.jpg" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Ex-officio</b></p>
                        </div>
                      </div></td>
                  </tr>

                  <tr>
                    <td>
                    <b>Dr. K P Naveen</b><br />
                      Associate Professor <br />
                      Department of Electrical Engineering
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/naveenkp.jpg" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Ex-officio</b></p>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                    <b>Dr. Chandra Sekhar Bahinipati</b><br />
                      Associate Professor<br />
                      Department of Humanities and Social Sciences
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/chandrabahinipati.jpg" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Ex-officio</b></p>
                        </div>
                      </div></td>
                  </tr>

                  <tr>
                    <td>
                    <b>Dr. Ishapathik Das</b><br />
                      Associate Professor<br />
                      Department of Mathematics and Statistics
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/ishap.jpg" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Ex-officio</b></p>
                        </div>
                      </div></td>
                  </tr>
                
                  <tr>
                    <td>
                    <b>Prof. Mamilla Ravi Sankar</b><br />
                      Professor<br />
                      Department of Mechanical Engineering
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/EVMRS.JPG" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Ex-officio</b></p>
                        </div>
                      </div></td>
                  </tr>
                  <tr>
                    <td>
                    <b>Dr. Rudra Sekhar Manna</b><br />
                      Associate Professor<br />
                      Department of Physics
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/Rudra.jpg" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Ex-officio</b></p>
                        </div>
                      </div></td>
                  </tr>

                  <tr>
                    <td className="text-center">
                      <Link className='c-link'>Professors of the Institute</Link>
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>
                    <b>Prof. B. Krishna Prapoorna</b><br />
                      Professor<br />
                      Department of Civil and Environmental Engineering
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/krishna1.jpg" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Ex-officio</b></p>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                    <b>Prof. Thamida Sunil Kumar</b><br />
                      Professor<br />
                      Departement of Chemical Engineerimg
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/Thamida_sunil_kumar_2019.jpg" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Ex-officio</b></p>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                    <b> Prof. N. Balakrishna</b>
                      <br />
                      Department of Mathematics & Statistics
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/Prof_N_ Balakrishna.png" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Ex-officio</b></p>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                    <b>Prof. Ramanathan Ayothiraman</b><br />
                      Professor<br />
                      Department of Civil and Environmental Engineering
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/Prof_Ramanathan_Ayothiraman.jpg" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Ex-officio</b></p>
                        </div>
                      </div>
                    </td>
                  </tr>
                 

                  {/* <tr>
                    <td>
                    <b> Prof. Thamida Sunil Kumar</b>
                      <br />
                      Department of Chemical Engineering
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/Thamida_sunil_kumar_2019.jpg" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Ex-officio</b></p>
                        </div>
                      </div>
                    </td>
                  </tr> */}
            
                  
                    
                  <tr>
                    <td className="text-center">
                      <Link className="c-link">
                        Educationists of Repute
                      </Link>
                    </td>
                    <td></td>
                  </tr>

                  <tr>
                    <td>
                    <b> Prof. Gandham Phanikumar</b> <br />
                      Professor <br />
                      Department of Metallurgical and Materials Engineering, IIT Madras
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/gphani.png" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Member</b></p>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>
                    <b>Prof. Phaneendra K. Yalavarthy</b><br />
                      Professor <br />
                      Department of Computational and Data Sciences, IISc Bangalore
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/Phaneendra.png" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Member</b></p>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                    <b>Prof. Badri Narayan Rath</b><br />
                      Professor <br />
                      Department of Liberal Arts, IIT Hyderabad
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/Badri_NR.png" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Member</b></p>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <Link className="c-link">
                        Distinguished Persons from Industry / R & D / Financial Institutions	
                      </Link>
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>
                    <b> Dr. R Vijay</b>
                      <br />
                      Director, ARCI Hyderabad
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/R_Vijay.png" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Member</b></p>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                    <b> Dr. Krishna Chaitanya Vishnubhatla</b> <br />
                      Senior Manager, Design Evaluation Engineer, Analog Devices India Pvt. Ltd. Bangalore
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/noimages.png" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Member</b></p>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <Link className="c-link">
                        Departmental Members
                      </Link>
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>
                    <b> Dr. Anil Vir</b>
                      <br />
                      Assistant Professor, Department of Chemical Engineering
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/anilvir.jpg" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Member</b></p>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                    <b> Dr. Debasish Mondal</b> <br />
                      Associate Professor, Department of Chemistry
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/dmondal.jpg" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Member</b></p>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                    <b> Dr. Bijily Balakrishnan</b> <br />
                      Assistant Professor, Department of Civil and Environmental
                      Enginnering
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/bijili.jpg" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Member</b></p>
                        </div>
                      </div>
                    </td>
                  </tr>


                  <tr>
                    <td>
                    <b>  Dr. Ramakrishna G </b> <br />
                      Assistant Professor, Department of Computer Science and Engineering
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/rama2.png" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Member</b></p>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>
                    <b> Dr. Pooja Vyavahare </b><br />
                      Assistant Professor, Department of Electrical Enginnering
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/PoojaV.png" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Member</b></p>
                        </div>
                      </div>
                    </td>
                  </tr>

{/*                   
                  <tr>
                    <td>
                      Dr. Mahendran V <br />
                      Assistant Professor, Department of Computer Science and
                      Engineering
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/mahendran.jpg" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Member</b></p>
                        </div>
                      </div>
                    </td>
                  </tr> */}


                  
                  <tr>
                    <td>
                    <b> Dr. Bibhuti Mary Kachhap</b>
                      <br />
                      Assistant Professor, Department of Humanities and Social Sciences
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/mary.jpg" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Member</b></p>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>
                    <b> Dr. Panchatcharam Mariappan</b> <br />
                      Associate Professor, Department of Mathematics and Statistics
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/PanchatcharamNUMA.jpg" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Member</b></p>
                        </div>
                      </div>
                    </td>
                  </tr>

                  {/* <tr>
                    <td>
                      Dr. Ishapathik Das
                      <br />
                      Assistant Professor, Department of Mathematics and
                      Statistics
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/ishap.jpg" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Member</b></p>
                        </div>
                      </div>
                    </td>
                  </tr> */}
                  <tr>
                    <td>
                    <b> Dr. Girish Kumar Rajan</b>
                      <br />
                      Associate Professor, Department of Mechanical Engineering
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/Girish.jpg" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Member</b></p>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>
                    <b> Dr. Aravinda S </b><br />
                      Assistant Professor, Department of Physics
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/Arv.JPG" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Member</b></p>
                        </div>
                      </div>
                    </td>
                  </tr>

                  {/* <tr>
                    <td>
                      Dr. Vinay Pramod Majety
                      <br />
                      Assistant Professor, Department of Physics
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/vinay.jpg" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Member</b></p>
                        </div>
                      </div>
                    </td>
                  </tr> */}
                  <tr>
                    <td>
                      <Link className="c-link">Invitees</Link>
                    </td>
                    <td></td>
                  </tr>

                  <tr>
                    <td>
                    <b> Dr. Durga Prasad Challa</b><br />
                      Associate Professor<br />
                      Chairperson, Admissions
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/durga1.jpg" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Ex-officio</b></p>
                        </div>
                      </div></td>
                  </tr>
                  
                  <tr>
                    <td>
                    <b> Dr. Madan Mohan Avulapati</b><br />
                      Associate Professor<br />
                      Advisor, Academic Courses
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/madan_new.jpg" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Ex-officio</b></p>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>
                    <b> Dr. Rajesh Viswanathan</b><br />
                    Professor <br />
                     Dean, Academic Affairs, IISER Tirupati
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://www.iisertirupati.ac.in/oldwebsite/faculty/rajesh/rajesh.jpg" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Ex-officio</b></p>
                        </div>
                      </div>
                    </td>
                  </tr>
                  
                  <tr>
                    <td>
                    <b> Dr. Degala Venkata Kiran</b><br />
                      Associate  Professor<br />
                      Workshop In-charge
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/D.V. Kiran.jpg" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Ex-officio</b></p>
                        </div>
                      </div></td>
                  </tr>
                  <tr>
                    <td>
                    <b> Dr. Prasanna Venkatesh Sampath</b><br />
                      Associate Professor<br />
                      Chairperson, Council of Wardens
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/venkatpv.jpg" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Ex-officio</b></p>
                        </div>
                      </div></td>
                  </tr>
              
                  <tr>
                    <td>
                    <b>Shri. Prashanta Kumar Behera</b><br />
                    Deputy Librarian
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/Staff/Prashanta_Kumar_Behera_DL.png" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Ex-officio</b></p>
                        </div>
                      </div></td>
                  </tr>
                  <tr>
                    <td className="text-center">
                      <Link className="c-link">
                        Special Invitees for Non-evaluation items
                      </Link>
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Students General Secretary</td>
                    <td>Ex-officio</td>
                  </tr>
                  <tr>
                    <td>Academic Affairs Secretary</td>
                    <td>Ex-officio</td>
                  </tr>
                  <tr>
                    <td>Research Affairs Secretary</td>
                    <td>Ex-officio</td>
                  </tr>
                </tbody>
              </table>
            </Col>
          </Row>
        </div>
      </section>
    </>
  );
}

export default Main;
